export function deleteAttachmentPairsReducer(state, action) {
    if (!state) {
        return undefined;
    }
    const newState = Object.assign({}, state);
    action.payload.attachmentIds.forEach(id => delete newState[id]);
    return newState;
}
//# sourceMappingURL=deleteAttachmentPairsReducer.js.map